import { render, staticRenderFns } from "./BtnAddCourse.vue?vue&type=template&id=381b8962"
import script from "./BtnAddCourse.vue?vue&type=script&lang=js"
export * from "./BtnAddCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports